import { Component, OnInit, ViewEncapsulation, signal } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { RouterOutlet } from '@angular/router';
import { CommonModule, JsonPipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from '../../shared/services/storage.service';
import { PingService } from '../../shared/services/ping.service';
import { FooterComponent } from './footer/footer.component';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { ClientPortalService } from '../../shared/services/client-portal.service';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, SidenavComponent, FooterComponent, RouterOutlet, CommonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements OnInit {

  isPwcEnabled = false;
  /** MP-5750: true for a client-portal session; the shell skips its firm-only loads. */
  readonly isClientPortalUser = signal(false);
  constructor(private cookieService:CookieService, private storageService: StorageService, 
    private pingService:PingService, private configurationService: ConfigurationService,
    private clientPortalService: ClientPortalService) {
    this.isClientPortalUser.set(this.clientPortalService.isClientPortalUser());
  }

    isMobile = this.cookieService.get('isMobile') === 'true';
    isSideNavOpen!: boolean;
    
    ngOnInit(): void {
    this.isSideNavOpen = this.isMobile? false: this.storageService.getSideNavToggle();
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    if (!this.isClientPortalUser()) {
      this.pingService.startPinging();
    }
  }

  onToggleSideNav(): void {
    this.isSideNavOpen = !this.isSideNavOpen;
    if(!this.isMobile){
      this.storageService.setSideNavToggle(this.isSideNavOpen);
    }
  }

  ngOnDestroy(): void{
    this.pingService.stopPinging();
  }
}
